export const environment = {
  production: true,
  contentSwitch: 'FWG',
  shareCallbackUri: 'https://www.zorginspirator.nl',
  prismicEndpoint: 'https://skillskompas.cdn.prismic.io/api/v2',
  prismicApiToken: 'MC5ZRmh1V2hJQUFDRUFFZm0y.bO-_vSN4SUMk77-9Ij5L77-977-9TxJc77-977-9W--_vRkCK0B0Au-_vWIUN--_vXc',
  prismicTags: ['zi']
};
